import { useQuery } from '@tanstack/react-query';
import { getGoalsList } from '../api';
import type { GoalFilters } from '../types';

export const GOALS_QUERY_KEY = 'goals';

interface UseGoalsOptions {
  filters?: GoalFilters;
  enabled?: boolean;
}

export function useGoals({
  filters, enabled = true 
}: UseGoalsOptions = {}) {
  return useQuery({
    queryKey: [GOALS_QUERY_KEY, filters],
    queryFn: () => getGoalsList(filters),
    enabled,
    staleTime: 30_000,
    gcTime: 5 * 60 * 1000,
  });
}
